import Colors from "./colors";
export const siteTheme = {
  breakpoints: [480, 768, 990, 1220],
  space: [0, 5, 10, 15, 20, 25, 30, 40, 56, 71, 91],
  fontSizes: [10, 12, 14, 15, 16, 20, 24, 36, 48, 55, 60, 81],
  fontWeights: [300, 400, 500, 600, 700, 800, 900],
  lineHeights: {
    solid: 1,
    title: 1.25,
    copy: 1.5,
  },
  letterSpacings: {
    normal: "normal",
    tracked: "0.1em",
    tight: "-0.05em",
    mega: "0.25em",
  },
  fonts: {
    roboto: '"Roboto", sans-serif',
  },
  borders: [0, "1px solid", "2px solid", "4px solid"],
  radius: [0, 3, 5, 10, 15, 20, 25, 50, 60, "50%"],
  colors: Colors,
  colorStyles: {
    primary: {
      color: Colors.primary,
      borderColor: Colors.primary,
      "&:hover": {
        color: Colors.primaryHover,
        borderColor: Colors.primaryHover,
      },
    },
    secondary: {
      color: Colors.secondary,
      borderColor: Colors.secondary,
      "&:hover": {
        color: Colors.secondaryHover,
        borderColor: Colors.secondaryHover,
      },
    },
    warning: {
      color: Colors.yellow,
      borderColor: Colors.yellow,
      "&:hover": {
        color: Colors.yellowHover,
        borderColor: Colors.yellowHover,
      },
    },
    error: {
      color: Colors.secondaryHover,
      borderColor: Colors.secondaryHover,
      "&:hover": {
        color: Colors.secondary,
        borderColor: Colors.secondary,
      },
    },
    primaryWithBg: {
      color: Colors.white,
      backgroundColor: Colors.primary,
      borderColor: Colors.primary,
      "&:hover": {
        backgroundColor: Colors.primaryHover,
        borderColor: Colors.primaryHover,
      },
    },
    secondaryWithBg: {
      color: Colors.white,
      backgroundColor: Colors.secondary,
      borderColor: Colors.secondary,
      "&:hover": {
        backgroundColor: Colors.secondaryHover,
        borderColor: Colors.secondaryHover,
      },
    },
    warningWithBg: {
      color: Colors.white,
      backgroundColor: Colors.yellow,
      borderColor: Colors.yellow,
      "&:hover": {
        backgroundColor: Colors.yellowHover,
        borderColor: Colors.yellowHover,
      },
    },
    errorWithBg: {
      color: Colors.white,
      backgroundColor: Colors.secondaryHover,
      borderColor: Colors.secondaryHover,
      "&:hover": {
        backgroundColor: Colors.secondary,
        borderColor: Colors.secondary,
      },
    },
  },
  buttonStyles: {
    textButton: {
      border: 0,
      color: Colors.primary,
      padding: 0,
      height: "auto",
      backgroundColor: `${Colors.transparent}`,
    },
    outlined: {
      borderWidth: "1px",
      borderStyle: "solid",
      backgroundColor: Colors.transparent,
    },
    fab: {
      border: "0",
      width: "40px",
      height: "40px",
      padding: 0,
      borderRadius: "50%",
      justifyContent: "center",
      "span.btn-icon": {
        paddingLeft: 0,
      },
    },
    extendedFab: {
      border: "0",
      minWidth: "50px",
      height: "40px",
      borderRadius: "50px",
      justifyContent: "center",
    },
  },
};
